import { useMemo } from 'react';

const usePagination = ({
  data = [],
  totalCount = 0,
  page,
  pageSize,
  mode = 'server', // 'server' | 'client'
}) => {
  const paginatedData = useMemo(() => {
    if (mode === 'server') return data;

    const start = (page - 1) * pageSize;
    const end = start + pageSize;

    return data.slice(start, end);
  }, [data, page, pageSize, mode]);

  const effectiveTotal = mode === 'client' ? data.length : totalCount;

  const totalPages = Math.ceil(effectiveTotal / pageSize);

  return {
    data: paginatedData,
    totalCount: effectiveTotal,
    totalPages,
  };
};

export default usePagination;